import { getLogger } from "../utils/logging.js";
import { ElementPanic } from "./element-panic-mixin.js";
function PlayerPanicHandlerMixin(Base) {
  return class extends Base {
    /** The Player-Core logger instance */
    panicLogger = getLogger("PlayerPanic");
    connectedCallback() {
      super.connectedCallback && super.connectedCallback();
      this.addEventListener(ElementPanic, this.onPanic);
    }
    onPanic(event) {
      const error = event.detail;
      event.preventDefault();
      this.panicLogger.error(error);
      this.handlePanic(error);
    }
    /**
     * Super method for handling errors dispatched by player or children
     *
     * Does nothing
     */
    handlePanic(_error) {
    }
    disconnectedCallback() {
      this.removeEventListener(ElementPanic, this.onPanic);
      super.disconnectedCallback && super.disconnectedCallback();
    }
  };
}
export {
  PlayerPanicHandlerMixin
};
